<template>
    <div class="container">
      <div class="row">
        <div id="tracking" class="offset-md-2 offset-sm-1 col-md-8 col-sm-9">
          <div class="row">
                <div class="col-md-4 col-sm-12 m-0 p-0">
                    <div id="documentacion" class="col-12 row">
                        <label class="col-11  m-0 p-1 rounded-pill bg-info
                                      text-white text-center">
                            Expediente completo
                            <label ref="ok1" id="ok1" class="col-1 text-white m-0 pl-1 fa fa-check-circle-o d-none"></label>
                        </label>
                         <label ref="paso1" id="paso1" class="col-1 text-secondary m-0 pl-1 fa fa-chevron-circle-right  fa-2x"></label>
                    </div>
                    <div id="panel_documentacion" class="col-12 row pt-3 p-3">
                        <div class="card col-12 border border-info esquinas_redondeadas_right">
                            <div class=" p-1 m-0 border-bottom">
                                <b>Fecha:</b>
                                <small>{{ fecha_solicitud }}</small>
                            </div>
                            <div ref="banner1" id="banner1" class="col m-0 p-2 tarjeta">
                                <small>
                                    <dl class="m-0 p-0">
                                        <dt>Identificación oficial</dt>
                                        <dd>- Documento vigente</dd>
                                        <dd>- Validaciòn de identidad</dd>
                                        <dt>Comprobante de domicilio</dt>
                                        <dd>- Domicilio actual</dd>
                                        <dd>- Arraigo domiciliario</dd>
                                        <dt>Comprobante de ingresos</dt>
                                        <dd>- Tres ultimos meses</dd>
                                    </dl>
                                </small>
                            </div>
                        </div>
                        <!-- <div class="col-1 "> </div> -->
                    </div>
                </div>
                <div class="col-md-4 col-sm-12 m-0 p-0">
                    <div id="analisis" class="col-12 row">
                        <label ref="analisis" class="col-11  m-0 p-1 rounded-pill bg-secondary
                                      text-white text-center in_Active">
                            En Revisión
                            <label ref="ok2" id="ok2" class="col-1 text-white m-0 pl-1 fa fa-check-circle-o d-none"></label>
                        </label>
                        <label ref="paso2" id="paso2" class="col-1 text-secondary m-0 pl-1 fa fa-chevron-circle-right fa-2x"></label>
                    </div>
                    <div class="col-12 row pt-3  p-3 ">
                        <div ref="panel_analisis" id="panel_analisis" class="card col-12  border border-primary esquinas_redondeadas_right in_Active">
                            <div class=" p-1 m-0 border-bottom ">
                                <b>Fecha:</b>
                                <small>{{ fecha_analisis }}</small>
                            </div>
                            <div ref="banner2" id="banner2" class="col m-0 p-2 tarjeta">
                                <small>
                                    <dl class="m-0 p-0">
                                        <!-- <dt>Validacion de identidad</dt>
                                        <dd>- Llamada a referencias</dd>
                                        <dt>Capacidad de pago</dt>
                                        <dd>- Analisis de capacidad</dd> -->
                                        <dt><h6>Substatus:</h6></dt>
                                        <dd class="m-0 p-0 pl-3" v-for="an in analisis">
                                            <b> {{ an[0] }}</b>
                                            <br> - {{ an[1]  }}
                                        </dd>
                                    </dl>
                                   <h6>Condiciones:</h6>
                                    <div class="d-inline-flex p-1" v-for="con in condiciones">
                                        <span class="badge badge-warning">
                                        {{ con['contract_condition'] }}
                                        </span>
                                    </div>
                                </small>
                            </div>
                        </div>
                        <!-- <div class="col-1 "> </div> -->
                    </div>
                </div>
                <div class="col-md-4 col-sm-12 m-0 p-0">
                    <div id="final" class="col-12 row">
                        <label ref="final" class="col-11  m-0 p-1 rounded-pill bg-secondary
                                      text-white text-center in_Active">
                            {{texto_final}}
                        </label>
                    </div>
                    <div class="col-12 row pt-3 p-3">
                        <div  ref="panel_final" id="panel_final"
                              class="card col-12 border border-secondary esquinas_redondeadas_right
                                    in_Active">
                            <div class=" p-1 m-0 border-bottom">
                                <b>Fecha:</b>
                                <small>{{ fecha_final }}</small>
                            </div>
                            <div ref="banner3" id="banner3" class="col m-0 p-2 tarjeta">
                                <small>
                                    <dl class="m-0 p-0">
                                        <!-- <dt class="text-success">¡Felicidades!</dt>
                                        <br> -->
                                        <!-- <dt>Formalizaciòn</dt>
                                        <dd>- Entrega de documentos del vehiculo</dd>
                                        <dd>- Cotizacion de Poliza de seguro</dd>
                                        <dt>Etapas</dt> -->
                                        <dt><h6>Substatus:</h6></dt>
                                        <dd class="m-0 p-0 pl-3" v-for="aut in autorizado">
                                            <b> {{ aut[0] }}</b>
                                            <br> - {{ aut[1]  }}
                                        </dd>
                                    </dl>
                                    <h6>Notas:</h6>
                                    <div class="d-inline-flex p-1 " v-for="rec in recheazo">
                                        <div  class="badge badge-danger">
                                            {{ rec['contract_reject'] }}
                                        </div >
                                    </div>
                                </small>
                            </div>
                        </div>
                        <!-- <div class="col-1 "> </div> -->
                    </div>
                </div>
          </div>
        </div>
      <div ref="tsparticles2" class="d-none">
        <Particles id="tsparticles2"
                  :particlesInit="particlesInit"
                  :particlesLoaded="particlesLoaded"
                  :options="opciones"/>
      </div>
      </div>
    </div>
</template>

  <script>
   import { loadFull } from "tsparticles";
  export default {
    name: "Tracking",
    data() {
      return {
        condiciones: [],
        recheazo: [],
        autorizado: [],
        analisis: [],
        texto_final: "Resultado",
        confeti: false,
        fecha_solicitud: "",
        fecha_analisis: "",
        fecha_final: "",
        global_result : [],
        opciones: {
                      fullScreen: {
                        zIndex: 1
                      },
                      particles: {
                        color: {
                          value: [
                            '#F59019',
                            '#2759AB',
                            '#ffcb63',
                            '#ffb4a9',
                            '#49c9ff',
                            '#49c9ff'
                          ]
                        },
                        move: {
                          direction: 'bottom',
                          enable: true,
                          outModes: {
                            default: 'out'
                          },
                          size: true,
                          speed: {
                            min: 1,
                            max: 5
                          }
                        },
                        number: {
                          value: 500,
                          density: {
                            enable: true,
                            area: 800
                          }
                        },
                        opacity: {
                          value: .7,
                          animation: {
                            enable: false,
                            startValue: 'max',
                            destroy: 'min',
                            speed: 0.5,
                            sync: true
                          }
                        },
                        rotate: {
                          value: {
                            min: 0,
                            max: 360
                          },
                          direction: 'random',
                          move: true,
                          animation: {
                            enable: true,
                            speed: 60
                          }
                        },
                        tilt: {
                          direction: 'random',
                          enable: true,
                          move: true,
                          value: {
                            min: 0,
                            max: 360
                          },
                          animation: {
                            enable: true,
                            speed: 60
                          }
                        },
                        shape: {
                          type: [
                            'circle',
                            'square'
                          ],
                          options: {}
                        },
                        size: {
                          value: {
                            min: 2,
                            max: 4
                          }
                        },
                        roll: {
                          darken: {
                            enable: true,
                            value: 30
                          },
                          enlighten: {
                            enable: true,
                            value: 30
                          },
                          enable: true,
                          speed: {
                            min: 15,
                            max: 25
                          }
                        },
                        wobble: {
                          distance: 20,
                          enable: true,
                          move: true,
                          speed: {
                            min: -15,
                            max: 15
                          }
                        }
                      },
                      detectRetina: true
        },
      };
    },
    validations() {
      return {};
    },
    methods: {
        particlesInit(main){
            loadFull(main);
        },
        particlesLoaded (container) {
            //console.log("Particles container loaded", container);
        },
        getHistory() {
            this.$StatusHistory.getHistory()
            .then((result) => {
                this.global_result = result;
                let estados = this.$UtilityService
                              .array_column_conditional(this.global_result.data.status_history, 'type','orderindex');

                this.fecha_solicitud =
                    new Date(Number(this.global_result.data.status_history[0].total_time.since));
                this.fecha_solicitud = this.formateDateTime(this.fecha_solicitud);

                Object.entries(estados).forEach(([key, value], index) => {
                    if(value ==  "custom" ){
                        this.validarCustum(Number(key),index);
                    } else {
                        this.validarDone(Number(key));
                    }
                });
                this.$StatusHistory.getCondition()
                .then((result) => {
                    this.condiciones = result.data;
                }, (err) => {this.$swal("CUIDADO!",err.msg,'error');this.preloaderHiden();});

                this.permisos();
                setTimeout(() => {
                  this.confetiActive();
                },5000);
            }, (err) => {this.$swal("CUIDADO!",err.msg,'error');this.preloaderHiden();});
        },
        validarCustum(custom, index){
            let fecha =
                new Date(Number(this.global_result.data.status_history[index].total_time.since));
            fecha = this.formateDateTime(fecha);
            let estatus = this.global_result.data.status_history[index].status;
            switch (custom) {
                    case 0:
                    case 1:
                        break;
                    case 2:
                        this.fecha_analisis = fecha;
                        this.analisis.push([estatus, fecha]);
                        this.showAnalisis();
                        break;
                    case 9:
                        this.fecha_final = fecha;
                        this.showAutorizado();
                        break;
                    default:
                        if(Number(custom) >= 9){
                            this.autorizado.push([estatus, fecha]);
                            this.showAutorizado();
                        } else {
                            this.analisis.push([estatus, fecha]);
                        }
                        break;
            }
            //this.$swal("datos!",paso,'error');
        },
        validarDone(done){
            switch (done) {
                    case 18:
                        this.showAutorizado();
                        break;
                    case 25:case 24:case 23:
                    case 22:case 21:case 20:case 19:
                        this.showRechazado();
                        break;
            }
        },
        showAutorizado() {
            this.confeti = true;
            setTimeout(() => {
                this.showAnalisis();
                setTimeout(() => {
                    this.$refs.panel_final.classList.remove('in_Active');
                    this.$refs.panel_final.classList.remove('border-secondary');
                    this.$refs.panel_final.classList.add('border-success');
                    this.$refs.final.classList.remove('in_Active');
                    this.$refs.final.classList.remove('bg-secondary');
                    this.$refs.final.classList.add('bg-success');
                    this.$refs.paso2.classList.add('text-success');
                    this.$refs.ok2.classList.remove('d-none');
                }, 500);
            }, 1500);
        },
        showRechazado() {
            this.confeti = false;
            this.$StatusHistory.getReject()
                .then((result) => {
                    this.recheazo =  result.data;
                }, (err) => {this.$swal("CUIDADO!",err.msg,'error');this.preloaderHiden();});

            setTimeout(() => {
                this.showAnalisis();
                setTimeout(() => {
                    this.$refs.panel_final.classList.remove('in_Active');
                    this.$refs.panel_final.classList.remove('border-secondary');
                    this.$refs.panel_final.classList.add('border-danger');
                    this.$refs.final.classList.remove('in_Active');
                    this.$refs.final.classList.remove('bg-secondary');
                    this.$refs.final.classList.add('bg-danger');
                    this.texto_final = "Rechazado";
                    this.$refs.paso2.classList.add('text-danger');
                    this.$refs.ok2.classList.add('d-none');
                }, 200);
            }, 1500);
        },
        showAnalisis() {
            this.$refs.panel_analisis.classList.remove('in_Active');
            this.$refs.analisis.classList.remove('in_Active');
            this.$refs.analisis.classList.remove('bg-secondary');
            this.$refs.analisis.classList.add('bg-primary');
            this.$refs.paso1.classList.add('text-success');
            this.$refs.ok1.classList.remove('d-none');
        },
        formateDateTime(fecha) {
            return  fecha.toLocaleString('es', {
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    });
        },
        permisos(){
            let tipo = localStorage.getItem("tipo");
            if (tipo != "ACESOR") {
                this.$refs.banner1.classList.add('d-none');
                this.$refs.banner2.classList.add('d-none');
                this.$refs.banner3.classList.add('d-none');
            }
        },
        confetiActive(){
            if(this.confeti == true) {
                this.$refs.tsparticles2.classList.remove('d-none');
                setTimeout(() => {
                    this.$refs.tsparticles2.classList.add('d-none');
                }, 7000);
            }
        },
        preloader() {
            $(".preloader").fadeIn();
            $(".preloader")
                .delay(10)
                .fadeIn("slow");
        },
        preloaderHiden() {
            $(".preloader").fadeOut();
            $(".preloader")
                .delay(10)
                .fadeOut("slow");
        }
    },
    mounted() {
      window.scrollTo(0, 210);
    },
    created() {
        //this.preloader();
        this.getHistory();
        //this.preloaderHiden();
    }
  };
  </script>

  <style lang="scss">
    .esquinas_redondeadas_right {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
    }
    .in_Active {
        opacity: 0.3;
    }
    .tarjeta {
        min-height: 280px;
    }
  </style>



// WEBPACK FOOTER //
// src/views/Tracking/Tracking.vue